export function debug<T>(item: T, tag?: string): T {
	const prefix = tag ? `<${tag}>` : '';
	console.log(`${prefix} debug: `, item);

	return item;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(): void { }
